import { render, staticRenderFns } from "./editor-layer-header.vue?vue&type=template&id=3ca8bd01&"
import script from "./editor-layer-header.vue?vue&type=script&lang=js&"
export * from "./editor-layer-header.vue?vue&type=script&lang=js&"
import style0 from "./editor-layer-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports